import axios from 'axios';
import { getToken } from 'utils/auth';

const BASE = process.env.REACT_APP_SURVEY_API_URL + '/api';

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  'Content-Type': 'application/json',
});

export const getRoles = () =>
  axios
    .get(`${BASE}/roles`, { headers: authHeaders() })
    .then((r) => r.data);

export const getPermissionsCatalog = () =>
  axios
    .get(`${BASE}/permissions`, { headers: authHeaders() })
    .then((r) => r.data);

export const createRole = (data) =>
  axios
    .post(`${BASE}/roles`, data, { headers: authHeaders() })
    .then((r) => r.data);

export const updateRole = (id, data) =>
  axios
    .put(`${BASE}/roles/${id}`, data, { headers: authHeaders() })
    .then((r) => r.data);

export const deleteRole = (id) =>
  axios
    .delete(`${BASE}/roles/${id}`, { headers: authHeaders() })
    .then((r) => r.data);
